@if (hasShadow$ | async) {
  <div class="shadow"></div>
}
@if (
  {
    authorized: isAuthenticated$ | async,
    isPresentation: isPresentationMode$ | async,
  };
  as data
) {
  <div class="wrapper h-100" [class.bare-layout]="bareLayout">
    @if (data.authorized && !hideHeader) {
      <app-header> </app-header>
    }
    @if (storeService.isLoading$ | async) {
      <app-progress-bar class="position-absolute w-100"></app-progress-bar>
    }
    <div class="content" [ngClass]="{ logged: isAuthenticated$ | async }">
      <app-banner-container></app-banner-container>
      <div class="pane-container">
        @if (data.authorized && !hideHeader) {
          <app-main-menu></app-main-menu>
        }
        <router-outlet></router-outlet>
      </div>
      <ng-toast></ng-toast>
    </div>
    @if (userHasBackgroundTasks$ | async) {
      <app-user-background-task-list
        [userBackgroundTasks]="userBackgroundTasks$ | async"
      ></app-user-background-task-list>
    }
    @if (userAccessLevel >= UserAccessLevel.GLOBAL_ADMIN) {
      <app-release-notes> </app-release-notes>
    }
  </div>
}
